import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { ExperienceFieldsFragment, ExperienceType } from '@/generated/graphql';
import EventActions from './event-actions';
import { OneOnOneActions } from './one-on-one-actions';
import { BoxActions } from './box-actions';

const BoxExperience = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 20px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: row;
    row-gap: unset;
    justify-content: center;
    column-gap: 30px;
  }
`;
const BoxOnlyTitle = styled(Typography)`
  color: #747474;
  text-align: center;
  font-size: 18px;
  font-family: var(--font-work-sans);
  font-style: normal;
  font-weight: 400;
  line-height: 159.3%;
  @media (max-width: 768px) {
    color: #7c7c7c;
    font-size: 16px;
    font-weight: 500;
    line-height: 157.3%;
    width: 60%;
    text-align: start;
  }
`;
export interface BookingActionsProps {
  experience: ExperienceFieldsFragment;
}
const BookingActions = ({ experience }: BookingActionsProps) => {
  const type = experience?.type;
  return (
    <div>
      {type === ExperienceType.Event && <EventActions experience={experience} />}
      {type === ExperienceType.Box && (
        <>
          <BoxExperience>
            <BoxOnlyTitle>All boxes are free - just pay for shipping!</BoxOnlyTitle>
            <BoxActions experience={experience} />
          </BoxExperience>
        </>
      )}
      {type === ExperienceType.Schedule && <OneOnOneActions experience={experience} />}
    </div>
  );
};

export default BookingActions;
